var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-fullwidth is-loading",class:_vm.variant,style:({height: _vm.height+'em'})})
}
var staticRenderFns = []

export { render, staticRenderFns }